import { render } from "./invoices.vue?vue&type=template&id=054c6549&scoped=true&ts=true"
import script from "./invoices.vue?vue&type=script&lang=ts"
export * from "./invoices.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./invoices.vue?vue&type=style&index=1&id=054c6549&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054c6549"]])

export default __exports__